module.exports = __webpack_public_path__ + "img/athmovil.7789c56e.png";